function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIdeeaLogoInverse = function SvgIdeeaLogoInverse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 243 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    }
  }, props), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M457.301 268.542h16.309v77.652h-16.309z",
    transform: "matrix(-.82325 0 0 .82325 390.788 -221.077)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-44.172c-2.808-2.376-7.921-3.564-15.336-3.564-1.584 0-3.654.054-6.21.162-2.557.108-4.266.162-5.13.162V3.456h15.985C-5.005 3.456-.539.648 2.7-4.968 5.579-9.936 7.021-16.019 7.021-23.22 7.021-33.227 4.68-40.212 0-44.172m10.045 54.756C5.293 14.688-.828 16.74-8.315 16.74h-34.237v-77.652h34.561c7.271 0 13.246 1.693 17.928 5.076 4.463 3.169 7.883 7.705 10.259 13.608 2.16 5.473 3.241 11.593 3.241 18.36 0 6.912-1.153 13.429-3.457 19.548-2.376 6.409-5.688 11.377-9.935 14.904",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    },
    transform: "translate(55.302 50.146) scale(.82325)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 50.22h41.256V31.455H3.348V17.847h37.908V0H0v-13.716h57.132v77.652H0V50.22Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    },
    transform: "translate(131.561 11.292) scale(.82325)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 19.116-9.72-30.888h-.216l-9.828 30.888H0Zm27.216 29.268H9.522L4.668 32.4h-28.59l-5.554 15.984h-17.072l27.542-77.652H-.214l27.43 77.652Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    },
    transform: "translate(220.208 24.095) scale(.82325)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 77.652h-57.051V0H.081v13.716h-41.256v17.847h37.907v13.608h-37.907v18.765H0v13.716Z",
    style: {
      fill: "#ffa100",
      fillRule: "nonzero"
    },
    transform: "translate(126.1) scale(.82325)"
  }));
};

export default SvgIdeeaLogoInverse;